export default {
    name: 'notificationservice',
    dependencies: ['xhrservice', 'loginservice', 'objectstore'],
    callable(xhr, loginservice, objectstore) {
        const notificationCountKey = 'notification_count';
        const deferredMarkIdsKey = 'deferred_mark_notifications';

        init();

        function getNumberOfNewNotifications() {
            return loginservice.isLoggedIn()
                ? _getNumberOfNewNotifications()
                : Promise.resolve(0);
        }

        function resetNotificationsCountCache() {
            objectstore.del(notificationCountKey);
        }

        function _getNumberOfNewNotifications() {
            const cache = _cacheGet();
            if (cache) {
                return Promise.resolve(cache.numberOfNewNotifications);
            }
            return xhr
                .getJson('/user/numberofnewnotifications.json')
                .then(data => {
                    objectstore.put(notificationCountKey, data, 2 * 60);
                    return data.numberOfNewNotifications;
                })
                .catch(() => 0);
        }

        function _cacheGet() {
            try {
                return objectstore.get(notificationCountKey);
            } catch (e) {
                return null;
            }
        }

        function _getStoredMarks() {
            try {
                return window.sessionStorage.getItem(deferredMarkIdsKey);
            } catch (e) {
                return null;
            }
        }

        function _getPendingMarks() {
            if ('sessionStorage' in window) {
                const id = _getStoredMarks();
                try {
                    window.sessionStorage.removeItem(deferredMarkIdsKey);
                } catch (e) {}
                return id;
            }

            return '';
        }

        function _markIdAsSeen(id) {
            return xhr
                .request({
                    url: '/notifications/mark-seen.json',
                    method: 'post',
                    data: {
                        id,
                    },
                })
                .then(() => ({ result: 'success' }))
                .catch(() => ({ result: 'failure' }));
        }

        function _markPendingIdAsSeen() {
            const id = _getPendingMarks();
            if (id) {
                return _markIdAsSeen(id);
            }
        }

        function markIdAsSeen(id) {
            if ('sessionStorage' in window) {
                try {
                    window.sessionStorage.setItem(deferredMarkIdsKey, id);
                } catch (e) {
                    _markIdAsSeen(id);
                }
            } else {
                _markIdAsSeen(id);
            }
        }

        function init() {
            _markPendingIdAsSeen();
        }

        return {
            getNumberOfNewNotifications,
            resetNotificationsCountCache,
            markIdAsSeen,
        };
    },
};



// WEBPACK FOOTER //
// ./services/notificationservice.js